import { IRequestBuilder } from "../../src/server/requests/RequestBuilder";
import ConsoleUtil from "../utils/ConsoleUtil";
import IComm from "./IComm";

/**
 * Handles communication with the server.
 */
export default class Comm implements IComm {
    public headers: any[] = [];

    /**
     * Send http request to server. Upon completion, a callback is executed, if provided.
     * @param request {Object} - Pre-built Request
     * @param callback {Function} - callback to execute on successful completion
     * @param callbackScope {Object} - the scope of the callback
     * @param errorCallback {Function} - callback to execute on error
     */
    send(
        request: IRequestBuilder,
        callback: (...args: any[]) => void,
        callbackScope: any,
        errorCallback?: (...args: any[]) => void,
        withCredentials = false
    ) {
        const xhttp = new XMLHttpRequest();
        const comm = this;
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                let response;
                if (this.responseText.indexOf("html") != -1) {
                    response = this.responseText;
                } else {
                    try {
                        response = JSON.parse(this.responseText);
                    } catch (e) {
                        errorCallback(e);
                    }
                }
                if (comm.checkForGlobalErrors(response) == false) {
                    ConsoleUtil.log("[BaseComm] Response: ", response);

                    callback(response);
                } else {
                    // todo - handle api error globally
                    errorCallback(response);
                }
            } else if (this.readyState == 4 && this.status == 404) {
                errorCallback({errorCode: 404, errorMessage: "Not Found"});
            } else {
                // todo - handle http error
                if (
                    (this.status == 500 || this.status == 400) &&
                    this.readyState == 4
                ) {
                    const response = JSON.parse(this.responseText);
                    let error_type = "API_ERROR";
                    const error_id =
                        this.status == 400 ? response.code : response.requestId;
                    if (error_id == 104) {
                        error_type = "CRITICAL_ERROR";
                    }

                    errorCallback(response);
                    // TODO Display Error
                }
            }
        };

        xhttp.onerror = (e) => {
            errorCallback(e);
            // TODO start Error
        };

        const params = request.requestData;

        if (request.method == "GET") {
            const paramString = Object.keys(params)
                .map((key) => key + "=" + encodeURIComponent(params[key]))
                .join("&");

            xhttp.open(request.method, request.path + "?" + paramString, true);
            this.headers.forEach((el: any) => {
                xhttp.setRequestHeader(el.name, el.value);
            });
            xhttp.send(null);
        } else if (request.method == "POST") {
            xhttp.open(request.method, request.path, true);
            xhttp.withCredentials = withCredentials;
            xhttp.setRequestHeader(
                "Content-Type",
                "application/json; charset=UTF-8"
            );
            this.headers.forEach((el: any) => {
                xhttp.setRequestHeader(el.name, el.value);
            });
            xhttp.send(JSON.stringify(params));
        }
    }

    /**
     * Check for global errors.
     * Intended to check for errors which are global in context and not meant to be handled by the
     * controllers which initiated the communication.
     * @private
     * @param response {Object} communication response
     * @returns {boolean}
     */
    checkForGlobalErrors(response: any) {
        return false;
    }
}
